import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/intelligence`;

const intelligenceService = {
  listAlerts: (facilityId) => apiClient.get(`${base(facilityId)}/alerts`),
  maintenanceForecast: (facilityId) => apiClient.get(`${base(facilityId)}/maintenance-forecast`),
  acknowledgeAlert: (facilityId, payload) =>
    apiClient.post(`${base(facilityId)}/alerts/acknowledge`, payload),
};

export default intelligenceService;
